import type { NavItem } from "../types";
import shell from "./shell.json";

/**
 * Menus e links do rodapé vivem em `shell.json`, lido também pelo tema PHP
 * (cabeçalho e rodapé das páginas fora do React). Edite lá, não aqui.
 */

/** Barra principal: as secções da home, na ordem em que aparecem. */
export const mainNav: NavItem[] = shell.mainNav;

/**
 * Menu lateral (hambúrguer): mesmos destinos do menu principal, mas sem
 * agrupamentos — os filhos de "Productes" entram na lista plana, porque o
 * submenu com hover de `mainNav` não existe no drawer.
 */
export const sideNav: NavItem[] = mainNav.flatMap((item) =>
	item.children?.length ? item.children : [item],
);

/** Coluna "Premsa" do rodapé. */
export const pressLinks: NavItem[] = shell.pressLinks;

/** Coluna "Pàgines legals" do rodapé. */
export const legalNav: NavItem[] = shell.legalNav;
